import { em } from 'polished'
import styled from 'styled-components'

import { BoxBase } from 'styles/components/layout'

export const BoxBaseStyled = styled(BoxBase)`
  min-height: ${p => (p.minHeight ? p.minHeight : 'auto')};
`

export const TextWrapper = styled.div`
  max-width: ${em(450)};
  display: inline-block;
  color: ${p => p.theme.colors.black};
  text-align: center;
  opacity: 0;
`

export const Num = styled.div`
  font-size: ${em(238)};
  line-height: 0.823529412;
  padding-bottom: ${em(18, 238)};
  opacity: 0;
`

export const NumWrapper = styled.div`
  display: flex;
  justify-content: center;
  color: ${p => p.theme.colors.black};
  position: relative;
  opacity: 1;
`

export const IconWrapper = styled.div`
  width: ${em(165)};
  height: ${em(165)};
  align-self: center;
  margin-left: ${em(20)};
  position: absolute;
  transform: scale(90) rotateZ(45deg);
`
